import type { Router } from 'vue-router';
import { configureDynamicParamsMenu } from '../helper/menuHelper';
import { Menu } from '../types';
import { PermissionModeEnum } from '@/enums/appEnum';
import { useAppStoreWithOut } from '@/store/modules/app';

import { usePermissionStoreWithOut } from '@/store/modules/permission';
import {GoingNewUtils, StorageUtils} from 'xmgoing-utils';
import {RoleEnum} from "@/enums/roleEnum";
import apps from "@/migo/apps";
import {hasSubApp} from "@/hooks/setting/usePageFlush";

function dealUnitAdminToHome({to,next}){
  const unitPath=StorageUtils.getSessionItem("unitPortalUrl");
  //如果设置了关闭单位空间 则跳转到指定界面 如果没有关闭单位空间 还是正常跳转
  if(GoingNewUtils.parseBoolean(StorageUtils.getSessionItem('closeUnitSpaceSel')+'')){
    if(to.name==='Analysis'){
      if(unitPath){
        if(hasSubApp(apps, unitPath)){
          setTimeout(()=>{
            next({ path: (unitPath+"") });
          },300);
          return;
        }else{
          next({ path: (unitPath+"") });
        }
      }else{
        next({ path: ("/unitAdminPageShow") });
      }
    }
  }
}
export function createParamMenuGuard(router: Router) {
  const permissionStore = usePermissionStoreWithOut();
  router.beforeEach(async (to, _, next) => {
    //判断是否存在指定单位门户url
    if(StorageUtils.getSessionItem("loginUserType")===RoleEnum.USER_UNIT_ROLE){
      dealUnitAdminToHome({to,next});
    }
    //判断是否存在指定用户门户url
    if(StorageUtils.getSessionItem("loginUserType")===RoleEnum.USER_ROLE){
      if(to.name==='Analysis'&&StorageUtils.getSessionItem("userPortalUrl")){
        const userPortUrl=(StorageUtils.getSessionItem("userPortalUrl")+"");
        //如果是子应用地址
        if(hasSubApp(apps, userPortUrl)){
          setTimeout(()=>{
            next({ path: (userPortUrl+"") });
          },300);
          return;
        }
        next({ path: userPortUrl});
      }
    }
    // filter no name route
    if (!to.name) {
      next();
      return;
    }
    // menu has been built.
    if (!permissionStore.getIsDynamicAddedRoute) {
      next();
      return;
    }
    let menus: Menu[] = [];
    if (isBackMode()) {
      menus = permissionStore.getBackMenuList;
    } else if (isRouteMappingMode()) {
      menus = permissionStore.getFrontMenuList;
    }
    menus.forEach((item) => configureDynamicParamsMenu(item, to.params));

    next();
  });
}

const getPermissionMode = () => {
  const appStore = useAppStoreWithOut();
  return appStore.getProjectConfig.permissionMode;
};

const isBackMode = () => {
  return getPermissionMode() === PermissionModeEnum.BACK;
};

const isRouteMappingMode = () => {
  return getPermissionMode() === PermissionModeEnum.ROUTE_MAPPING;
};
